<template>
  <div :class="{'checkin__last-call--expired': hdExpired}"
       class="checkin__last-call checkin__last-call--list d-flex align-items-center justify-content-between">
    <div>
      <template v-if="hdExpired">
        <span style="font-size: 18px" class="mr-1">&#127881;</span> {{ $t('pages.checkins.last_call_expired') }}
      </template>
      <template v-else>
        <Icon name="alertTriangle" width="20" class="mr-2"/>
        {{ $t('pages.checkins.last_call') }}
      </template>
    </div>
    <div>
      <b-button size="sm" class="" variant="outline">
        {{ $t('pages.checkins.last_call_btn') }}
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "InfoHdAvailableList",
  props: {
    hdAvailableTo: {
      type: String,
      required: true
    }
  },
  computed: {
    hdExpired() {
      return new Date(this.hdAvailableTo) < new Date()
    },
  },
}
</script>


<style scoped>

</style>